module.exports = __webpack_public_path__ + "img/icon_guessing.488bb11f.png";